module.exports = __webpack_public_path__ + "img/JDBa.6aaffad7.png";